/**
 * Exercise API service
 * Handles exercise-related API calls
 */

import { apiGet } from "./api";

/**
 * Exercise content URL response
 */
export interface ExerciseContentUrlResponse {
  content_url: string;
  filename: string;
  content_type: string;
}

/**
 * Get a signed URL for exercise content (e.g., PDF presentations)
 * @param exerciseId - The exercise UUID
 * @returns Promise with content URL, filename, and content type
 */
export async function getExerciseContentUrl(
  exerciseId: string,
): Promise<ExerciseContentUrlResponse> {
  return apiGet<ExerciseContentUrlResponse>(
    `/exercises/${exerciseId}/content-url`,
  );
}
